import { useEffect, useState } from "react";
import styles from "./PanNotLinked.module.scss";

// libraries
import Swal from "sweetalert2";

// components
import MainHeader from "../../components/Header/MainHeader";
import CustomButton from "../../components/Button/CustomButton";
import ServicesAPI from "../../services/services";
import useResponse from "../../hooks/useResponse";
import {
  googleEvent_LOJ206,
  googleEvent_LOJ208,
  googleEvent_LOJ209,
  googleEvent_LOJ217,
} from "../../lib/google-analytics";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useNavigate } from "react-router-dom";

export default function PanNotLinked() {
  const [data, setData] = useState(null);

  const navigate = useNavigate();
  const { panAadhaarMismatchClick, aadhaarPanReverify } = new ServicesAPI();
  const { handleStep } = useResponse();

  useEffect(() => {
    fetchAPI();
    googleEvent_LOJ206();
  }, []);

  const fetchAPI = async () => {
    const { rekycButtonMessages } = new ServicesAPI();
    const res = await rekycButtonMessages();

    if (res && res.statusCode === 200) {
      setData(res.data);
    }
  };

  const handlePanAadhaarMismatch = async () => {
    const res = await panAadhaarMismatchClick();

    if (res && res.statusCode === 200) {
      window.location.href = "https://www.incometax.gov.in/iec/foportal/help/how-to-link-aadhaar";
    }
  };

  const handleAadhaarPanReverify = async () => {
    const res = await aadhaarPanReverify();

    if (res && res.statusCode === 200) {
      Swal.fire({
        position: "top-center",
        icon: "success",
        title: "Verified Successfully",
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2000,
      });
       setTimeout(() => {
        navigate("/home");
        // handleStep();
      }, 2000);
    } else if (res.statusCode === 400) {
      Swal.fire({
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = res.data.route;
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text: res.message,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
      if(!data) {
        handleShowContextualLoader("Please wait...");
        return;
      } else {
        handlehideContextualLoader();
      }
      return () => {
        handlehideContextualLoader();
      };
    }, [data]);

  if (!data) {
    return null;
  }
  return (
    <>
      <div className="wrapper">
        <div className={`vertical-column-layout ${styles.pan__aadhaarVerify}`}>
          <div className="vertical-column-top">
            <MainHeader title="" />

            <div className={styles.aadhaarImage}>
              <img src="/images/comdined.webp" alt="" />
              <h3>{data?.msg1}</h3>
              <p>{data?.msg2}</p>
            </div>
          </div>

          <div className="vertical-column-bottom">
            {data.isLinkedDone !== "0" && (
              <CustomButton
                floating={false}
                text="My Aadhaar & PAN is Linked"
                variant="outline"
                onClick={() => {
                  handleAadhaarPanReverify();
                  googleEvent_LOJ208();
                  googleEvent_LOJ217();
                }}
              />
            )}
            <br />
            <CustomButton
              floating={false}
              text="Link my Aadhaar & PAN"
              variant="outline"
              onClick={() => {
                handlePanAadhaarMismatch();
                googleEvent_LOJ209();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
